import { render, staticRenderFns } from "./shop-earnings.vue?vue&type=template&id=83f13672&scoped=true"
import script from "./shop-earnings.vue?vue&type=script&lang=js"
export * from "./shop-earnings.vue?vue&type=script&lang=js"
import style0 from "./shop-earnings.vue?vue&type=style&index=0&id=83f13672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f13672",
  null
  
)

export default component.exports